/**
 * Ryan O'Dowd
 * 2022-07-07
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({colors}) => {
  return {
    text: {
      display: 'flex',
      textAlign: 'center',
      marginTop: 8,
      marginBottom: 4,
      color: colors.white,
    },
    updateButtonWrapper: {
      display: 'flex',
      alignSelf: 'center',
      margin: 8,
    },
  };
};

export default getStyles;
